import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Seo from '../../components/Seo';
import { getStaticMeta } from '../../seo/pageMeta';

const LegalNoticeScreen = () => {
  const { t, i18n } = useTranslation();
  const meta = getStaticMeta('legal', i18n.language);

  return (
    <div className="min-h-screen bg-bg pt-28 pb-24 md:pt-32">
      <Seo title={meta.title} description={meta.description} path="/legal" />
      <div className="mx-auto max-w-page px-6">
        <article className="max-w-3xl mx-auto prose prose-invert prose-headings:text-body prose-a:text-primary prose-p:text-muted prose-li:text-muted">
          <h1>{t('legal.legalNotice.title')}</h1>
          <p className="text-sm !text-muted">
            {t('legal.legalNotice.lastUpdated')}
          </p>

          <section>
            <h2>{t('legal.legalNotice.sections.legalInfo.title')}</h2>
            <p>{t('legal.legalNotice.sections.legalInfo.content')}</p>
            <ul>
              <li><strong className="text-body">{t('legal.legalNotice.sections.legalInfo.fields.identity')}</strong> : Samy Bidar</li>
              <li><strong className="text-body">{t('legal.legalNotice.sections.legalInfo.fields.legalForm')}</strong> : {t('legal.legalNotice.sections.legalInfo.values.legalForm')}</li>
              <li><strong className="text-body">{t('legal.legalNotice.sections.legalInfo.fields.tradeName')}</strong> : Alturion Labs</li>
              <li><strong className="text-body">{t('legal.legalNotice.sections.legalInfo.fields.siret')}</strong> : 815 220 702 00030</li>
              <li><strong className="text-body">{t('legal.legalNotice.sections.legalInfo.fields.professionalAddress')}</strong> : 39 Bd Maurice Pourchon, 63100 Clermont-Ferrand</li>
              <li><strong className="text-body">{t('legal.legalNotice.sections.legalInfo.fields.phone')}</strong> : 06 98 50 37 79</li>
              <li><strong className="text-body">{t('legal.legalNotice.sections.legalInfo.fields.email')}</strong> : support@alturionlabs.com</li>
            </ul>
          </section>

          <section>
            <h2>{t('legal.legalNotice.sections.publication.title')}</h2>
            <p>{t('legal.legalNotice.sections.publication.content')}</p>
          </section>

          <section>
            <h2>{t('legal.legalNotice.sections.hosting.title')}</h2>
            <p>{t('legal.legalNotice.sections.hosting.content')}</p>
            <p>
              <strong className="text-body">{t('legal.legalNotice.sections.hosting.appHostLabel')}</strong>
            </p>
            <ul>
              <li><strong className="text-body">{t('legal.legalNotice.sections.legalInfo.fields.companyName')}</strong> : Railway Corporation</li>
              <li><strong className="text-body">{t('legal.legalNotice.sections.legalInfo.fields.address')}</strong> : 548 Market St, PMB 68956, San Francisco, CA 94104, USA</li>
              <li><strong className="text-body">{t('legal.legalNotice.sections.legalInfo.fields.phone')}</strong> : +1 (415) 707-7675</li>
              <li><strong className="text-body">Website</strong> : https://railway.com</li>
            </ul>
            <p className="mt-4">
              <strong className="text-body">{t('legal.legalNotice.sections.hosting.domainLabel')}</strong>
            </p>
            <ul>
              <li><strong className="text-body">{t('legal.legalNotice.sections.legalInfo.fields.companyName')}</strong> : Namecheap, Inc.</li>
              <li><strong className="text-body">{t('legal.legalNotice.sections.legalInfo.fields.address')}</strong> : 4600 East Washington Street, Suite 305, Phoenix, AZ 85034, USA</li>
              <li><strong className="text-body">Website</strong> : https://www.namecheap.com</li>
            </ul>
          </section>

          <section>
            <h2>{t('legal.legalNotice.sections.intellectualProperty.title')}</h2>
            <p>{t('legal.legalNotice.sections.intellectualProperty.content1')}</p>
            <p>{t('legal.legalNotice.sections.intellectualProperty.content2')}</p>
          </section>

          <section>
            <h2>{t('legal.legalNotice.sections.personalData.title')}</h2>
            <p>{t('legal.legalNotice.sections.personalData.content1')}</p>
            <p>{t('legal.legalNotice.sections.personalData.content2')}</p>
            <p>
              {t('legal.legalNotice.sections.personalData.content3')}{' '}
              <Link to="/privacy">{t('legal.legalNotice.sections.personalData.privacyLink')}</Link>.
            </p>
          </section>

          <section>
            <h2>{t('legal.legalNotice.sections.cookies.title')}</h2>
            <p>
              {t('legal.legalNotice.sections.cookies.content')}{' '}
              <Link to="/cookies">{t('legal.legalNotice.sections.cookies.cookieLink')}</Link>.
            </p>
          </section>

          <section>
            <h2>{t('legal.legalNotice.sections.liability.title')}</h2>
            <p>{t('legal.legalNotice.sections.liability.content1')}</p>
            <p>{t('legal.legalNotice.sections.liability.content2')}</p>
            <ul>
              {t('legal.legalNotice.sections.liability.list', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section>
            <h2>{t('legal.legalNotice.sections.law.title')}</h2>
            <p>{t('legal.legalNotice.sections.law.content')}</p>
          </section>

          <section>
            <h2>{t('legal.legalNotice.sections.contact.title')}</h2>
            <p>{t('legal.legalNotice.sections.contact.content')}</p>
            <ul>
              <li><strong className="text-body">{t('legal.legalNotice.sections.legalInfo.fields.email')}</strong> : support@alturionlabs.com</li>
            </ul>
          </section>
        </article>
      </div>
    </div>
  );
};

export default LegalNoticeScreen;
